import { Checkbox } from '@arco-design/web-react'
import cs from 'classnames'
import './index.less'

export default function NewCheckBox(props) {
    return <Checkbox {...props} className={cs("redqueenCheckbox", props.className)} />
}
